import React from 'react';

import Header from '../containers/Header.jsx';
import Navigator from '../containers/Navigator.jsx';
import Footer from '../containers/Footer.jsx';
import Text from '../simple_components/Text.jsx';
import Image from '../simple_components/Image.jsx';

import '../styles/NewsDettaglio.scss';

function NewsDettaglio(props){
    return(
        <>
            <Header setLanguage={props.setLanguage} {...props.header} />
            <Navigator {...props.navigator} />
            <div id={props.id} className={props.className}>
                <div className={props.container_className}>
                    <Text {...props.text} />
                </div>
                {props.images.map((image,index)=>(<Image key={index} {...image} />))}
            </div>
            <Footer />
        </>
    );
}

export default NewsDettaglio;